import React from "react";
import { CommonModule } from "uca-react-containers-library";
import ucaEnv from "../../../common/env/env-uca";
import { useApi } from "../../../hooks";

const Rewards = ({}) => {
  /*  const {
    appData: { banner, env, platform },
  } = CommonModule.useApp();
  const environmentVariables = ucaEnv(banner, env, platform);
  const { loading, data, error } = useApi(
    `${environmentVariables.REWARDS_PAGE_BASE_API}/rewards`
  ); */

  return (
    <div className="help-wrapper">
      <h2>Rewards</h2>
    </div>
  );
};

export default Rewards;
